import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.js";
import Highlight from 'react-highlight.js';
import { Link, GiveMeSomeSpace } from '../components/elements.js';
import { InitialAndAnimate, Variants, HoverAndTap, Drag, Scroll, Modal } from '../components/examples.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`🤔 What is Framer motion?`}</h2>
    <p>{`An open source React library to power production-ready animations.`}</p>
    <strong>📚 TLDR;</strong>
    <p>{`It's an amazing react animation library that allows you to easily
add animations to your site all through Javascript. It's also really fast using your GPU to achieve 60 FPS animations.`}</p>
    <div>
  <Link href="https://www.framer.com/motion/" mdxType="Link">
    🔗Check out their site, its pretty...cool 🧊
  </Link>
    </div>
    <GiveMeSomeSpace mdxType="GiveMeSomeSpace" />
    <h2>{`🚀Installation`}</h2>
    <Highlight language="shell" mdxType="Highlight">$ npm i framer-motion --save</Highlight>
    <Highlight language="js" mdxType="Highlight">{`
import {motion} from 'framer-motion';
${`
`}
<motion.div>I'm animatable</motion.div>
`}</Highlight>
    <GiveMeSomeSpace mdxType="GiveMeSomeSpace" />
    <h2>{`🏃🏼‍♀️Let's animate an element!`}</h2>
    <p>{`To start animating, we just have to convert an HTML element, into a `}<inlineCode parentName="p">{`<motion.element />`}</inlineCode>{`.`}</p>
    <p>{`Then you can set an `}<strong parentName="p">{`initial`}</strong>{` prop and an `}<strong parentName="p">{`animate`}</strong>{` prop to get started!`}</p>
    <p>{`It's super easy, here are some examples of what you can animate:`}</p>
    <ul>
  <li>
    <span role="img">✅</span>opacity
  </li>
  <li>
    <span role="img">✅</span>scale
  </li>
  <li>
    <span role="img">✅</span>skew
  </li>
  <li>
    <span role="img">✅</span>rotate
  </li>
  <li>
    <span role="img">✅</span>x
  </li>
  <li>
    <span role="img">✅</span>y
  </li>
    </ul>
    <p>{`We can also control the duration and delay with a `}<strong parentName="p">{`transition`}</strong>{` prop.`}</p>
    <InitialAndAnimate mdxType="InitialAndAnimate" />
    <h2>{`You can also do these on hover and tap! 👆🏼`}</h2>
    <HoverAndTap mdxType="HoverAndTap" />
    <h2>{`Framer motion uses these things called variants`}</h2>
    <p><strong parentName="p">{`Variants`}</strong>{` allow you to define animation states and organize them by name.`}</p>
    <p>{`They allow us to control animations throughout a component tree by switching a single `}<strong parentName="p">{`animate`}</strong>{` prop.`}</p>
    <p>{`This is great for `}<strong parentName="p">{`orchestration`}</strong>{`!`}</p>
    <Variants mdxType="Variants" />
    <h2>{`Drag, is no longer a drag`}</h2>
    <p>{`To make a component draggable, you just add a `}<strong parentName="p">{`drag`}</strong>{` prop and what axis you want it to drag on.`}</p>
    <p>{`If you don't want the element to be yeeted off the page, you can add the `}<strong parentName="p">{`dragContraints`}</strong>{` prop.`}</p>
    <p>{`If you want the `}<strong parentName="p">{`dragContraints`}</strong>{` to be the size of the parent's, you can pass it the `}<br />{` parents `}<inlineCode parentName="p">{`dragContraints={parentRef}`}</inlineCode>{`.`}</p>
    <Drag mdxType="Drag" />
    <h1>{`Scroll`}</h1>
    <p>{`You can create scroll animations with the `}<inlineCode parentName="p">{`useViewportScroll`}</inlineCode>{` hook framer motion provides. You can create effects like parallax or progress bars!`}</p>
    <Scroll mdxType="Scroll" />
    <h1>{`Let's put it all together!`}</h1>
    <p>{`Let's make a modal with everything we have learned.`}</p>
    <Modal mdxType="Modal" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      